exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-289bdbcf] {\n  font-size: 15px;\n  font-weight: bold;\n  margin-right: 12px;\n}\n.img-timeline-card[data-v-289bdbcf] {\n  max-height: 600px;\n  overflow: hidden;\n}\n", ""]);

// exports
